<template>
  <v-row class="d-flex justify-center my-2">
    <div class="d-flex d-inline-flex ma-0 pa-0">
      <v-menu
        v-model="menuFrom"
        ref="menuFrom"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            readonly
            v-bind="attrs"
            v-on="on"
            v-model="formatDateFrom"
            :label="$tc('changeSchedule.from')"
            required
            :rules="rules"
            style="max-width: 200px"
            outlined
            dense
            hide-details
            class="mr-2"
          />
        </template>
        <v-date-picker
          locale="es-es"
          no-title
          scrollable
          v-model="chageDateFrom"
          @input="menuFrom = false"
        >
        </v-date-picker>
      </v-menu>
      <v-menu
        v-model="menuTo"
        ref="menuTo"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            readonly
            v-bind="attrs"
            v-on="on"
            v-model="formatDateTo"
            :disabled="checkTo == true"
            :label="$tc('changeSchedule.to')"
            style="max-width: 200px"
            outlined
            dense
            hide-details
            class="mr-2"
          />
        </template>
        <v-date-picker
          locale="es-es"
          no-title
          scrollable
          v-model="changeDateTo"
          @input="menuTo = false"
        >
        </v-date-picker>
      </v-menu>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <span v-on="on" class="d-flex align-center">
            <v-simple-checkbox :ripple="false" color="accent" v-model="checkTo">
            </v-simple-checkbox>
          </span>
        </template>
        <span>{{ $tc("changeSchedule.caducity") }}</span>
      </v-tooltip>
    </div>
  </v-row>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      menuFrom: false,
      menuTo: false,
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
    };
  },

  computed: {
    chageDateFrom: {
      get: function () {
        return this.$store.state.employees.dateFrom;
      },
      set: function (newDate) {
        if (newDate > this.$store.state.employees.dateTo) {
          this.setDateTo(newDate);
        }
        this.setDate(newDate);
      },
    },
    changeDateTo: {
      get: function () {
        return this.$store.state.employees.dateTo;
      },
      set: function (date) {
        if (date < this.$store.state.employees.dateFrom) {
          this.setDate(date);
        }
        this.setDateTo(date);
      },
    },
    checkTo: {
      get() {
        return this.$store.state.employees.checkTo;
      },
      set(newValue) {
        this.setCheckTo(newValue);
      },
    },

    formatDateFrom: {
      get() {
        return moment(this.chageDateFrom).format("DD-MM-YYYY");
      },
      set(newValue) {
        return moment(newValue).format("DD-MM-YYYY");
      },
    },

    formatDateTo: {
      get() {
        if (this.changeDateTo == null) {
          return null;
        } else {
          return moment(this.changeDateTo).format("DD-MM-YYYY");
        }
      },
      set(newValue) {
        return moment(newValue).format("DD-MM-YYYY");
      },
    },
  },
  methods: {
    setDate(date) {
      this.$store.commit("employees/setDateFrom", date);
    },
    setDateTo(date) {
      this.$store.commit("employees/setDateTo", date);
    },
    setCheckTo(value) {
      this.$store.commit("employees/setCheckTo", value);
    },
  },
};
</script>

<style scoped></style>
